export const FLAG_GETTING_MAINTENANCE_ACTIVITY_SYSTEMS =
  'FLAG_GETTING_MAINTENANCE_ACTIVITY_SYSTEMS';
export const GET_MAINTENANCE_ACTIVITY_SYSTEMS =
  'GET_MAINTENANCE_ACTIVITY_SYSTEMS';
export const CLEAR_MAINTENANCE_ACTIVITY_SYSTEMS =
  'CLEAR_MAINTENANCE_ACTIVITY_SYSTEMS';
